import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import cx from 'clsx';
import { useTheme } from '../../../ThemeProvider';
import classes from './EventInfo.styles.less';
export default function EventInfo({ className, title, kbd, value, deprecation = false, }) {
    const [theme] = useTheme();
    return (_jsxs("div", { className: cx(classes.eventInfo, classes[theme], className), children: [_jsxs("div", { className: classes.title, children: [kbd && _jsx("div", { className: classes.kbd, children: kbd }), _jsx("div", { className: classes.titleLabel, children: title }), deprecation && _jsx("div", { className: classes.deprecation, children: "deprecated" })] }), _jsx("div", { className: cx(classes.value, {
                    [classes.boolean]: typeof value === 'boolean',
                    [classes.false]: !value,
                }), children: value.toString() === ' ' ? (_jsx("div", { className: classes.space, children: "(Space charachter)" })) : (value.toString()) })] }));
}
